var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('notifications',{staticClass:"base-toast-notifications pl-1 pb-1",attrs:{"notifications":_vm.items,"omit":"","hide-no-data":"","width":"min(400px, 100vw - 10px)"},on:{"click":_vm.click,"timeout":_vm.timeout}})}
var staticRenderFns = []

export { render, staticRenderFns }